<div class="view-help" #viewHelp> 
  <div class="view-help__inner" [ngSwitch]="activeTab">
    <!-- Close -->
    <div class="view-help__close" (click)="handleCloseClick()">
      <app-icon icon="times"></app-icon>
    </div>

    <!-- Tabs -->
    <div class="view-help__tabs">
      <div class="view-help__tab" (click)="handleTabClick('basics')" [ngClass]="{'view-help__tab--active': activeTab === 'basics'}">
        Navigation Basics
      </div>

      <div class="view-help__tab" (click)="handleTabClick('all')" [ngClass]="{'view-help__tab--active': activeTab === 'all'}">
        All Controls
      </div>
    </div>

    <!-- Basics -->
    <ng-container *ngSwitchCase="'basics'">

      <!-- Mouse controls -->
      <div class="view-help__group" *ngIf="!(canTouch$ | async)">
        <div class="view-help__item">
          <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-rotate.svg)'"></div>
          <div class="view-help__label">Rotate the model</div>
          Click and drag to rotate and view from other angles
        </div>

        <div class="view-help__item">
          <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-pan.svg)'"></div>
          <div class="view-help__label">Pan the model</div>
          Use the W, A, S, D keys to move side to side or up and down
        </div>

        <div class="view-help__item">
          <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-zoom.svg)'"></div>
          <div class="view-help__label">Zoom in and out</div>
          Use your scroll wheel or trackpad to zoom in and out
        </div>

        <div class="view-help__item">
          <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-learn.svg)'"></div>
          <div class="view-help__label">Explore the anatomy</div>
          Click on an anatomical structure or label to learn more
        </div>
      </div>

      <!-- Touch controls -->
      <div class="view-help__group" *ngIf="(canTouch$ | async)">
          <div class="view-help__item">
            <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-rotate.svg)'"></div>
            <div class="view-help__label">Rotate the model</div>
            Use one finger to rotate
          </div>
  
          <div class="view-help__item">
            <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-pan.svg)'"></div>
            <div class="view-help__label">Pan the model</div>
            Use two fingers to move up and down or side to side
          </div>
  
          <div class="view-help__item">
            <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-zoom.svg)'"></div>
            <div class="view-help__label">Zoom in and out</div>
            Pinch or expand to zoom in and out
          </div>
  
          <div class="view-help__item">
            <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-learn.svg)'"></div>
            <div class="view-help__label">Explore the anatomy</div>
            Tap a label to learn more and get a closer look
          </div>
        </div>

    </ng-container>

    <!-- All controls -->
    <ng-container *ngSwitchCase="'all'">
      <!-- Mouse -->
      <div class="view-help__header" *ngIf="!(canTouch$ | async)">
        Mouse
      </div>

      <div class="view-help__group" *ngIf="!(canTouch$ | async)">
        <div class="view-help__item">
          <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-mouse-hold-left.svg)'"></div>
          Hold left button to rotate
        </div>

        <div class="view-help__item">
            <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-mouse-hold-right.svg)'"></div>
          Hold right button to pan
        </div>

        <div class="view-help__item">
          <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-mouse-single-click-left.svg)'"></div>
          Single-click left button to select a structure
        </div>

        <div class="view-help__item">
          <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-mouse-double-click-left.svg)'"></div>
          Double-click left button to auto-focus on a structure
        </div>

        <div class="view-help__item">
          <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-mouse-long-press-left.svg)'"></div>
          Long-click to fly to a structure
        </div>
      </div>

      <!-- Keyboard -->
      <div class="view-help__header" *ngIf="!(canTouch$ | async)">
        Keyboard
      </div>

      <div class="view-help__group" *ngIf="!(canTouch$ | async)">
        <div class="view-help__item">
          <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-keyboard-rotate.svg)'"></div>
          Rotate with arrows
        </div>

        <div class="view-help__item">
          <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-keyboard-pan.svg)'"></div>
          Pan up (W), left (A), down (S), right(D)
        </div>

        <div class="view-help__item">
          <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-keyboard-zoom.svg)'"></div>
          Zoom out (-, C) and zoom in (+, E)
        </div>

        <div class="view-help__item">
          <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-keyboard-slow-motion.svg)'"></div>
          Hold with any previous key to slow down motion
        </div>
      </div>

      <!-- Trackpad -->
      <div class="view-help__header">
        Trackpad
      </div>

      <div class="view-help__group">
        <div class="view-help__item">
          <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-trackpad-single-tap.svg)'"></div>
          Single-tap to auto-focus a structure
        </div>

        <div class="view-help__item">
          <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-trackpad-double-tap.svg)'"></div>
          Double-tap to select a structure
        </div>

        <div class="view-help__item">
          <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-trackpad-long-press.svg)'"></div>
          Long-press to fly to a structure
        </div>

        <div class="view-help__item" *ngIf="!(canTouch$ | async)">
          <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-trackpad-scroll.svg)'"></div>
          Scroll up and down to zoom
        </div>
      </div>

      <!-- In-App -->
      <div class="view-help__header">
        In-App
      </div>

      <div class="view-help__group">
        <div class="view-help__item">
          <app-icon class="view-help__icon" icon="plus"></app-icon>
          Zoom in
        </div>

        <div class="view-help__item">
          <app-icon class="view-help__icon" icon="minus"></app-icon>
          Zoom out
        </div>

        <div class="view-help__item">
          <app-icon class="view-help__icon" icon="location-arrow"></app-icon>
          Recenter 3D model
        </div>

        <div class="view-help__item">
          <app-icon class="view-help__icon" icon="arrows"></app-icon>
          Pan
        </div>
      </div>
    </ng-container>
  </div>
</div>
